import { environment } from "../../../environments/environment";
import axios from "axios";

export async function fetchPanelSizeRestrictions() {
  const url = environment.getPanelSizeRestrictions;
  const response = await axios.get(url);
  // Si la respuesta es un objeto con 'load', retorna ese arreglo
  if (Array.isArray(response.data)) {
    return response.data;
  }
  if (response.data && Array.isArray(response.data.load)) {
    return response.data.load;
  }
  return [];
}
